import React, { Component } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError } from '../../components';
import { FiSearch } from 'react-icons/fi';

import Select, { selectComponents } from '../ReactSelect/ReactSelect';

import css from './FieldSelectModern.module.css';

class FieldSelectModernComponent extends Component {
  render() {
    /* eslint-disable no-unused-vars */
    const {
      rootClassName,
      className,
      inputRootClass,
      disabled,
      customErrorText,
      id,
      label,
      input,
      meta,
      onUnmount,
      isUncontrolled,
      inputRef,
      subHeading,
      placeholder,
      useSearchIcon,
      ...rest
    } = this.props;
    if (label && !id) {
      throw new Error('id required when a label is given');
    }

    const { valid, invalid, touched, error } = meta;
    const isTextarea = input.type === 'textarea';

    const errorText = customErrorText || error;
    const hasError = !!customErrorText || !!(touched && invalid && error);

    const fieldMeta = { touched: hasError, error: errorText };

    // Textarea doesn't need type.
    const { type, ...inputWithoutType } = input;
    // Uncontrolled input uses defaultValue instead of value.
    const { value: defaultValue, ...inputWithoutValue } = input;
    // Use inputRef if it is passed as prop.
    const refMaybe = inputRef ? { ref: inputRef } : {};

    const inputClasses =
      inputRootClass ||
      classNames(css.input, {
        [css.inputSuccess]: valid,
        [css.inputError]: hasError,
        [css.textarea]: isTextarea,
      });

    const customComponents = {
      IndicatorSeparator: () => null,
    };

    if (useSearchIcon) {
      customComponents.DropdownIndicator = () => null;
      customComponents.Control = ({ children, ...controlProps }) => (
        <selectComponents.Control {...controlProps}>
          <FiSearch className={css.searchIconInControl} />
          {children}
        </selectComponents.Control>
      );
    }

    // Prepare props for React Select
    const selectValue = isUncontrolled ? undefined : input.value || null;
    const selectDefaultValue = isUncontrolled ? defaultValue || null : undefined;

    const classes = classNames(rootClassName || css.root, className);
    return (
      <div className={classes} style={disabled ? { pointerEvents: 'none', opacity: '0.4' } : {}}>
        {label ? (
          <label htmlFor={id} className={css.label}>
            {label}
          </label>
        ) : null}
        <Select
          value={selectValue}
          defaultValue={selectDefaultValue}
          onChange={input.onChange}
          onBlur={input.onBlur}
          id={id}
          className={inputClasses}
          classNamePrefix="react-select"
          components={customComponents}
          placeholder={placeholder ? placeholder : <FiSearch className={css.searchIcon} />}
          styles={
            useSearchIcon ? { valueContainer: base => ({ ...base, paddingLeft: '6px' }) } : {}
          }
          {...rest}
        />
        <ValidationError fieldMeta={fieldMeta} />
      </div>
    );
  }
}

class FieldSelectModern extends Component {
  componentWillUnmount() {
    // Unmounting happens too late if it is done inside Field component
    // (Then Form has already registered its (new) fields and
    // changing the value without corresponding field is prohibited in Final Form
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  }

  render() {
    return <Field component={FieldSelectModernComponent} {...this.props} />;
  }
}

export default FieldSelectModern;
